export default __webpack_public_path__ + "static/media/news1.8e84f600.mp4";